import { Component, DestroyRef, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { MasterCatalogChildAccordionComponent } from '../../master-catalog/master-catalog-child-accordion/master-catalog-child-accordion.component';
import { ApiService } from '../../../Services/api.service';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../../../Common/Components/spinner/spinner.component";
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { BehaviorSubject, debounceTime, Subject, Subscription, switchMap } from 'rxjs';
import { tap } from 'lodash';

@Component({
  selector: 'app-add-product-details',
  standalone: true,
  imports: [NzButtonModule, NzDrawerModule, NzInputModule,
    MasterCatalogChildAccordionComponent, NzInputModule, NzCollapseModule,
    NzDropDownModule, NzIconModule, FormsModule, CommonModule, NzSelectModule,
    NzCollapseModule, SpinnerComponent, NzAutocompleteModule],
  templateUrl: './add-product-details.component.html',
  styleUrl: './add-product-details.component.scss'
})
export class AddProductDetailsComponent {
  constructor(public apiService: ApiService) { }
  selectedBrand: string = '';
  selectedGarment: string = '';
  selectedSubGarment: string = '';
  selectedProdctId: any;
  brandList: any = [];
  garmentList: any = [];
  subGarmentList: any = [];
  styleList: any = [];
  versionList: any = [];
  inValidProductSearch: boolean = false;
  hideSearch: boolean = false;
  searchProductList: any = [];
  selectedCatalogId: string = "";
  selectedProdctDetails: any;
  activeContainer: boolean = true;
  @Output() emitSelectedProduct = new EventEmitter<any>();
  @Output() emitResetAction = new EventEmitter<any>();
  @Input() catalogAddForm: boolean = false;
  @Input() applyStyleAction: boolean = false;
  @ViewChild(MasterCatalogChildAccordionComponent) private masterCatalogChildComponent!: MasterCatalogChildAccordionComponent;
  searchStyleIDText: string = "";
  lotIdtext: string = '';
  searchVersionText: string = "";
  pageNumber: number = 1;
  limit: number = 100;
  totalRecords: number = 0;
  showLoadMore: boolean = false;
  loadingData: boolean = false;
  metaFields: any;
  deletedInd: boolean = false;
  @Output() emitCopyAction = new EventEmitter<string>();
  @Input() resetListDetails: any;
  @Input() newMC: boolean = false;
  lotSearchChange$ = new Subject<string>();
  lotList: any = [];
  destroyRef = inject(DestroyRef);
  searchChange$ = new Subject<string>();
  searchSubscription!: Subscription;
  @ViewChild('lotSelect') selectComponent!: NzSelectComponent;


  ngOnInit(): void {
    this.getBrandList();
    this.getStyleList();
    this.searchSubscription = this.lotSearchChange$
      .pipe(
        debounceTime(300),
        switchMap((searchText) => this.apiService.getLotListBySearch(searchText))
      )
      .subscribe((response: any) => {
        this.lotList = response;
      });
  }

  onOpenChange(isOpen: any): void {

    if (isOpen) {
      this.lotList = [];
    }
  }

  toggleSearchBox() {

  }

  onLotSearch(value: string): void {

    value = value.toUpperCase();
    if (value && value.trim() !== '') {
      console.log(value)
      this.lotSearchChange$.next(value);
    } else {

      this.garmentList = [];
    }
  }


  ngOnChanges() {

    if (this.catalogAddForm) {
      this.selectedBrand = '';
      this.selectedGarment = '';
      this.selectedSubGarment = '';
      this.searchStyleIDText = '';
      this.lotIdtext = '';
      this.searchVersionText = '';
      this.searchProductList = [];
      this.loadingData = false;
      this.showLoadMore = false;
    }
    if (this.resetListDetails && this.resetListDetails.resetList && this.resetListDetails.selectedProdctId && this.resetListDetails.selectedVersion) {
      this.getSearchData();
      this.searchRefresh();
    }
    if(this.newMC){
      this.searchRefresh();
    }
  }

  searchRefresh() {
    this.getBrandList();
    this.getStyleList();
    if (this.selectedBrand) {
      this.getGarmentList(this.selectedBrand);
      if (this.selectedGarment) {
        this.subGarmentList(this.selectedGarment);
      }
    }
    if (this.searchStyleIDText) {
      this.getVersionList(this.searchStyleIDText);
    }
  }

  searchProductData(searchTerm: any) {
    this.searchStyleIDText = searchTerm;
    this.searchVersionText = searchTerm;
  }

  getBrandList() {
    this.apiService.getBrandList().subscribe((response: any) => {
      this.brandList = response;
    })
  }
  getStyleList() {
    this.apiService.getStyleIdList().subscribe((response: any) => {
      this.styleList = response;
    })
  }
  onSearchUpdated(searchText: string): void {
    this.searchStyleIDText = searchText;
  }

  clearVersionText(): void {
    this.searchVersionText = '';
  }


  ngAfterViewInit() {
    if (this.selectComponent) {
      this.selectComponent.focus();
    }
  }

  getVersionList(styleId: any) {
    if (styleId) {
      this.apiService.getStyleListById(styleId).subscribe(response => {
        this.versionList = response;
        this.versionList = this.versionList.filter((node: any) => node.version != '');
      });
    }
  }

  getGarmentList(brand: string, formFilter?: boolean) {
    this.selectedGarment = '';
    this.selectedSubGarment = '';
    this.apiService.getGarmentList(brand).subscribe((response: any) => {
      this.garmentList = response;
    })
  }

  getSubGarmentList(brand: string, garment: string, formFilter?: boolean) {
    this.selectedSubGarment = '';
    this.apiService.getSubGarmentList(brand, garment).subscribe((response: any) => {
      this.subGarmentList = response;
    })
  }

  getSearchData(loadMore = false) {

    if (!this.selectedBrand && !this.searchStyleIDText && !this.searchVersionText && !this.lotIdtext) {
      this.inValidProductSearch = true;
    } else {
      this.inValidProductSearch = false;
      if (!loadMore) {
        this.searchProductList = [];
        this.pageNumber = 1;
      } else {
        this.pageNumber++;
      }
      this.loadingData = true;
      this.apiService.getProductList(this.selectedBrand, this.selectedGarment,
        this.selectedSubGarment, this.searchStyleIDText, this.searchVersionText, this.pageNumber, this.limit, this.deletedInd, this.lotIdtext).subscribe(response => {
          this.loadingData = false;
          this.searchProductList.push(...response.data);
          this.metaFields = response.meta;
          this.totalRecords = response.meta?.total;
          this.searchProductList.map((node: any) => Object.assign(node));
          this.showLoadMore = this.searchProductList.length < this.totalRecords ? true : false;
        },
          error => {
            this.loadingData = false;
            // this.apiService.createNotification('error', error?.error.message);
          })
    }
  }

  loadMasterCatalogProduct(product: any) {
    this.selectedProdctId = product["styleId"];
    this.emitSelectedProduct.emit({ action: 'New', data: product });
  }

  resetSearch() {
    this.selectedBrand = '';
    this.selectedGarment = '';
    this.selectedSubGarment = '';
    this.searchVersionText = '';
    this.searchStyleIDText = '';
    this.lotIdtext = '';
    this.searchProductList = [];
    this.loadingData = false;
    this.showLoadMore = false;
    this.deletedInd = false;
    this.brandList = [];
    this.subGarmentList = [];
    this.garmentList = [];
    this.styleList = [];
    this.versionList = [];
    this.getStyleList();
    this.getBrandList();
    this.emitResetAction.emit(true);
  }

  handleCatalogAction(evt: any) {
    if (evt.action == 'Delete') {
      this.apiService.deleteProductDetails(evt.data.styleId, evt.data.version).subscribe(res => {
        this.apiService.createNotification('success', res.message);
        this.emitResetAction.emit(true);
        this.getSearchData();
        this.searchRefresh();

      }, err => {
        this.apiService.createNotification('error', err?.error.message);
      })
    }
    if (evt.action == 'Undelete') {
      this.apiService.unDeleteProductDetails(evt.data.styleId, evt.data.version).subscribe(res => {
        this.apiService.createNotification('success', res.message);
        this.emitResetAction.emit(true);
        this.getSearchData();
        this.searchRefresh();

      }, err => {
        this.apiService.createNotification('error', err?.error.message);
      })
    }
    if (evt.action == 'Merge') {
      this.masterCatalogChildComponent.mergeBtn = 'Merging';
      this.apiService.mergeProductDetails(evt.data).subscribe(res => {
        this.apiService.createNotification('success', res.message);
        this.masterCatalogChildComponent.mergeBtn = 'Merge';
        this.masterCatalogChildComponent.showMergeModal = false;
        this.emitResetAction.emit(true);
        this.getSearchData();
        this.searchRefresh();

      }, err => {
        this.loadingData = false;
        this.masterCatalogChildComponent.mergeBtn = 'Merge';
        this.apiService.createNotification('error', err?.error.message);
      })
    }
    if (evt.action == 'Move') {
      this.masterCatalogChildComponent.mergeBtn = 'Moving';
      this.apiService.moveProductDetails(evt.data).subscribe(res => {
        this.apiService.createNotification('success', res.message);
        this.masterCatalogChildComponent.moveBtn = 'Move';
        this.masterCatalogChildComponent.showMovePopup = false;
        this.emitResetAction.emit(true);
        this.getSearchData();
        this.searchRefresh();

      }, err => {
        this.loadingData = false;
        this.masterCatalogChildComponent.moveBtn = 'Move';
        this.apiService.createNotification('error', err?.error.message);
      })
    }

    if (evt.action == 'Copy') {
      this.emitSelectedProduct.emit(evt);
    }

  }

  onlyAlphanumeric(event: KeyboardEvent) {
    const key = event.key;

    const isControlKey = [
      'Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ].includes(key);

    if (isControlKey) {
      return;
    }

    const isAlphanumeric = /^[a-zA-Z0-9]$/.test(key);

    if (!isAlphanumeric) {
      event.preventDefault();
    }
  }

  hasDuplicateStyle(searchText: string): boolean {
    if (!this.styleList || !searchText) return false;
    return this.styleList.some((s: any) => s.styleId === searchText);
  }

  hasDuplicateVersion(searchText: string): boolean {
    if (!this.versionList || !searchText) return false;
    return this.styleList.some((v: any) => v.version === searchText);
  }

  ngOnDestroy(): void {
    // Unsubscribe when the component closes to prevent memory leaks
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }


}
